// @flow
import { useContext } from "react";
import { ThemeContext } from "styled-components";

import type { Theme } from "./types";

/**
 */
const useTheme = (): Theme => {
  return useContext(ThemeContext);
};

export { useTheme };
